import moment from 'moment';

export const requiredDefaultError = 'Не заполнено обязательное поле';

export function getRequiredFn(errorText = requiredDefaultError) {
  return (value) => {
    return value || value === 0 ? null : errorText;
  };
}

export function isValidDateBeforeToday() {
  return (value) => {
    if (value && !moment(value, 'YYYY-MM-DD').isValid()) {
      return 'Введенная дата не существует';
    }

    if (moment(value, 'YYYY-MM-DD').diff(moment()) >= 0) {
      return `Поле должно содержать дату не позднее ${moment().format('DD.MM.YYYY')}`;
    }

    return null;
  };
}

export function isAfter(date, errorText = 'Введите дату не ранее') {
  return (value) => {
    return (
      value &&
      moment(value, 'YYYY-MM-DD').diff(moment(date, 'DD.MM.YYYY')) < 0 &&
      `${errorText} ${date}`
    );
  };
}

export function isBeforeOrEqual(date, errorText = 'Дата не должна быть позднее') {
  return (value) => {
    return (
      value &&
      moment(value, 'YYYY-MM-DD').isAfter(moment(date, 'DD.MM.YYYY')) &&
      `${errorText} ${date}`
    );
  };
}

export function isSafeXMLCharacter(value) {
  const errorText = 'Введены недопустимые символы';
  if (!value) {
    return null;
  }

  const windows1251Regex =
    /[^ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—™љ›њќћџ !Ў"ў#Ћ$¤%Ґ&¦'§(Ё)©*Є+«,¬\-\u­.®\/Ї°±Ііґµ¶·ё№:є;»<=>?ї@a-zA-Zа-яА-Я0-9[\\\]^_`{|}~]/gm;

  return value.match(windows1251Regex) ? errorText : null;
}
